/* Odds Comfort: pack finder. Pick who it is for, the pack size and the sock height; it shows only what exists.
   Works from the lazy catalog (Odds.catalog), so it never offers a combination that is not in the shop.
   States: loading (skeleton), ready, error (catalog could not be read: retry once, then offer the shop). */
(function () {
  'use strict';
  var Odds = window.Odds;
  if (!Odds) return;
  var $ = Odds.$, $$ = Odds.$$;
  var CUT_ORDER = ['crew', 'quarter', 'ankle', 'noshow'];
  var DEPT_ORDER = ['men', 'women', 'kids'];

  function packsOf(p) {
    var out = {}, m, re = /(\d+)-pack/g, kw = p.kw || '';
    while ((m = re.exec(kw))) out[m[1]] = 1;
    if (!Object.keys(out).length && p.n) out[String(p.n)] = 1;
    return Object.keys(out);
  }

  function init(root) {
    if (root.__finder) return; root.__finder = true;
    var limit = Number(root.getAttribute('data-limit')) || 12;
    var S = { dept: '', pack: '', cut: '' };
    var q = new URLSearchParams(location.search);
    ['dept', 'pack', 'cut'].forEach(function (k) { if (q.get(k)) S[k] = q.get(k); });
    var grid = $('[data-f-results]', root), none = $('[data-f-none]', root), err = $('[data-f-error]', root), skel = $('[data-f-skeleton]', root), count = $('[data-f-count]', root);

    function setState(s) {
      root.classList.toggle('is-loading', s === 'loading');
      root.classList.toggle('is-error', s === 'error');
      if (skel) skel.hidden = s !== 'loading';
      if (err) err.hidden = s !== 'error';
      if (s !== 'ready') { grid.hidden = true; none.hidden = true; }
    }
    setState('loading');

    function ready(all) {
      var items = all.filter(function (p) { return p.d && p.c; }).map(function (p) { p.__packs = packsOf(p); return p; });
      if (!items.length) return false;
      var PACKS = []; items.forEach(function (p) { p.__packs.forEach(function (n) { if (PACKS.indexOf(n) < 0) PACKS.push(n); }); });
      PACKS.sort(function (a, b) { return Number(a) - Number(b); });
      var VALUES = {
        dept: DEPT_ORDER.filter(function (d) { return items.some(function (p) { return p.d === d; }); }),
        pack: PACKS,
        cut: CUT_ORDER.filter(function (c) { return items.some(function (p) { return p.c === c; }); })
      };
      /* ignore a choice from the link that does not exist */
      Object.keys(VALUES).forEach(function (g) { if (S[g] && VALUES[g].indexOf(S[g]) < 0) S[g] = ''; });

      function match(p, skip) {
        if (skip !== 'dept' && S.dept && p.d !== S.dept) return false;
        if (skip !== 'pack' && S.pack && p.__packs.indexOf(S.pack) < 0) return false;
        if (skip !== 'cut' && S.cut && p.c !== S.cut) return false;
        return true;
      }
      function label(group, v) {
        if (group === 'dept') return Odds.t('dept_' + v);
        if (group === 'cut') return Odds.t('cut_' + v);
        return Odds.plural('pairs', Number(v));
      }
      function inGroup(p, group, v) { return group === 'dept' ? p.d === v : group === 'cut' ? p.c === v : p.__packs.indexOf(v) > -1; }

      function chips(group) {
        var box = $('[data-f-group="' + group + '"]', root);
        var html = '<button type="button" data-v="" aria-pressed="' + (S[group] === '' ? 'true' : 'false') + '">' + Odds.esc(Odds.t('finder_any')) + '</button>';
        VALUES[group].forEach(function (v) {
          var n = items.filter(function (p) { return match(p, group) && inGroup(p, group, v); }).length;
          html += '<button type="button" data-v="' + Odds.esc(v) + '" aria-pressed="' + (S[group] === v ? 'true' : 'false') + '"' + (n === 0 ? ' disabled' : '') + '>' + Odds.esc(label(group, v)) + '<sup>' + n + '</sup></button>';
        });
        box.innerHTML = html;
      }

      function render() {
        ['dept', 'pack', 'cut'].forEach(chips);
        var hits = items.filter(function (p) { return match(p); }).sort(function (a, b) { return (b.a ? 1 : 0) - (a.a ? 1 : 0) || a.rank - b.rank; });
        count.textContent = Odds.plural('options', hits.length);
        grid.innerHTML = hits.slice(0, limit).map(Odds.render.card).join('');
        grid.hidden = hits.length === 0; none.hidden = hits.length > 0;
        $('[data-f-reset]', root).hidden = !(S.dept || S.pack || S.cut);
        var base = (S.dept && Odds.cfg.deptUrls && Odds.cfg.deptUrls[S.dept]) || Odds.url('/collections/all');
        var qs = []; if (S.cut) qs.push('cut=' + S.cut); if (S.pack) qs.push('pack=' + S.pack);
        $('[data-f-all]', root).setAttribute('href', base + (qs.length ? (base.indexOf('?') > -1 ? '&' : '?') + qs.join('&') : ''));
        var u = new URLSearchParams(); ['dept', 'pack', 'cut'].forEach(function (k) { if (S[k]) u.set(k, S[k]); });
        try { history.replaceState(null, '', location.pathname + (u.toString() ? '?' + u.toString() : '')); } catch (e) { /* ignore */ }
        Odds.emit('dom:updated');
      }

      root.addEventListener('click', function (e) {
        var b = e.target.closest('.fchips button');
        if (b && !b.disabled) { S[b.parentNode.getAttribute('data-f-group')] = b.getAttribute('data-v'); render(); return; }
        if (e.target.closest('[data-f-reset]')) { S.dept = S.pack = S.cut = ''; render(); }
      });
      setState('ready');
      render();
      return true;
    }

    function fail() { setState('error'); count.textContent = ''; }
    Odds.catalog.load().then(function (all) {
      if (ready(all)) return;
      /* the catalog came back empty: try once more, then show the error */
      setTimeout(function () { Odds.catalog.reload().then(function (again) { if (!ready(again)) fail(); }); }, 1200);
    }).catch(fail);
  }

  function boot() { $$('[data-finder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
